/**
 * "Add Account" button — drop-in for any page (Accounts list, empty state, etc.).
 * Owns the wizard's open/close state and triggers a parent refresh after close.
 */

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { AddAccountWizard } from "./wizard";

interface Props {
  /** Called after the wizard closes — parent should refetch its account list. */
  onComplete?: () => void;
  /** Optional override for the button label. */
  label?: string;
  /** Variant passthrough for the Button. */
  variant?: React.ComponentProps<typeof Button>["variant"];
  size?: React.ComponentProps<typeof Button>["size"];
  marketType?: "forex_cfd" | "futures";
}

export function AddAccountButton({
  onComplete,
  label = "Add Account",
  variant = "default",
  size = "default",
  marketType,
}: Props) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Button variant={variant} size={size} onClick={() => setOpen(true)}>
        {label}
      </Button>
      <AddAccountWizard
        open={open}
        onOpenChange={setOpen}
        onClose={() => onComplete?.()}
        marketType={marketType}
      />
    </>
  );
}
